import { Observable } from 'rxjs';

export interface RoomTypeOption {
  label: string;
  value: string;
}

export interface InputDialogData {
  title?: string;
  message?: string;
  label?: string;
  placeholder?: string;
  initialValue?: string;
  inputType?: 'text' | 'email' | 'password';
  primaryButton?: InputDialogButton;
  secondaryButton?: InputDialogButton;
  roomTypes?: RoomTypeOption[];
  defaultRoomType?: string;
  roomTypeLabel?: string;
  enableValuationSearch?: boolean;
  valuationSearchLabel?: string;
  roomSearchPlaceholder?: string;
  /**
   * When set, hides valuation search and shows the given message + link instead.
   */
  valuationBlockMessage?: string;
  valuationBlockLinkText?: string;
  valuationBlockLinkHref?: string;

  /**
   * Optional async confirm handler.
   * If provided (and returns an Observable), the dialog will keep open, show loading on primary button
   * and close only after the Observable emits (success) or show an inline error (failure).
   *
   * Return `null`/`undefined` to fall back to default sync close behavior.
   */
  confirmAction?: (payload: InputDialogResult) => Observable<unknown> | null | undefined;
}

export interface InputDialogButton {
  text: string;
  value?: any;
  style?: 'filled' | 'outlined' | 'destructive' | 'outlined-black' | 'outlined-orange' | 'outlined-red' | 'filled-black';
}

export interface InputDialogResult {
  confirmed: boolean;
  value?: string;
  buttonValue?: any;
  roomType?: string;
  searchResult?: any;
  valuationBlockLinkClicked?: boolean;
  /**
   * Result returned by InputDialogData.confirmAction (if used).
   */
  actionResult?: unknown;
}
